export const view = {
    methods:{
        submit: function(e){
            e.preventDefault();
            var _self = this;

            var parameters = this.getFormModel('form.register_form');
            parameters.FranchiseID = localStorage.franchiseID;
            parameters.ActivationUrl = window.location.origin + '/Activate?franchiseID=' + parameters.FranchiseID + '&emailAddress=' + parameters.Email;
            _self.$ooApi.orders.accounts.register.v1(parameters).then(function(response){
                if(response.success){
                    _self.$router.push('Registered');
                }
                else
                    console.log(response.message);
            })
            // check .catch
        }
    }
}